import { MapBoxMode, MapData } from 'src/app/base/shared/map-box-map/map-box-map.component';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClientDTO, ExtendedParkingRangerSessionDTO, ParkingRangerSessionDTO } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ParkingRangerSessionsService } from './parking-ranger-sessions.service';
import { DataManager } from '@syncfusion/ej2-data';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DateHelper, DATE_HELPER_DEFAULT_TIME_ZONE } from 'src/app/base/shared/date-helper';
import { Subscription } from 'rxjs';
import { ParkingRangerSessionDetailsListComponent } from './parking-ranger-session-details-list/parking-ranger-session-details-list.component';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { NgIf, NgClass } from '@angular/common';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { ClientAutocompleteComponent } from '../../base/shared/client-autocomplete/client-autocomplete.component';
import { TitleBarComponent } from '../../base/shared/title-bar/title-bar.component';
import { MapBoxMapComponent } from "../../base/shared/map-box-map/map-box-map.component";

@Component({
    selector: 'app-parking-ranger-sessions',
    templateUrl: './parking-ranger-sessions.component.html',
    styleUrls: ['./parking-ranger-sessions.component.scss'],
    imports: [
        TitleBarComponent,
        ReactiveFormsModule,
        ClientAutocompleteComponent,
        DatePickerModule,
        NgIf,
        GridModule,
        ButtonModule,
        NgClass,
        ParkingRangerSessionDetailsListComponent,
        TranslateModule,
        MapBoxMapComponent
    ]
})
export class ParkingRangerSessionsComponent extends GridBaseComponent implements OnInit, OnDestroy {

  public override get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public override set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
      this.onClientSelected(value);
    }
  }

  public get mapData(): MapData {
    return {
      data: this.selectedParkingRangerSession.positions
              .map(position => `${position.lat},${position.lon}`)
              .join(';'),
      mode: MapBoxMode.LineMode
    };
  }

  public today = new Date();
  public twoDaysAgo = new Date();
  public tabToggleStatus = false;
  public showContent = false;

  public parkingRangerSessions: ParkingRangerSessionDTO[];
  public selectedParkingRangerSession: ExtendedParkingRangerSessionDTO;
  public selectedParkingRangerSessionId: number;

  public timeForm: FormGroup<{startTime: FormControl<Date>; endTime: FormControl<Date>}> = this.fb.group({
    startTime: [new Date()],
    endTime: [new Date()],
  });

  MapBoxMode = MapBoxMode;

  private subscriptions = new Subscription();

  constructor(private fb: FormBuilder,
              translateService: TranslateService,
              clientService: ClientService,
              private parkingRangerSessionsService: ParkingRangerSessionsService,
              private spinnerService: SpinnerService) {
    super(clientService, translateService, parkingRangerSessionsService);
  }

  ngOnInit() {
    this.today.setHours(0, 0, 0, 0);
    this.timeForm.controls.endTime.setValue(this.today);
    this.twoDaysAgo.setHours(0, 0, 0, 0);
    this.twoDaysAgo.setDate(this.twoDaysAgo.getDate() - 2);
    this.timeForm.controls.startTime.setValue(this.twoDaysAgo);
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.parkingRangerSessionsService, this.spinnerService),
    });
    this.subscriptions.add(this.timeForm.controls.startTime.valueChanges.subscribe(() => {
      this.search();
    }));
    this.subscriptions.add(this.timeForm.controls.endTime.valueChanges.subscribe(() => {
      this.search();
    }));
    this.search();
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  public override onClientSelected(client: ClientDTO): void {
    this.showContent = false;
    this.search();
  }

  public search() {
    if (this.selectedClient) {
      this.parkingRangerSessionsService.getParkingRangerSessions(
        this.selectedClient.id,
        DateHelper.getDateTimeFromJsDateInTimeZone(this.timeForm.controls.startTime.value, DATE_HELPER_DEFAULT_TIME_ZONE)?.toString(),
        DateHelper.getDateTimeFromJsDateInTimeZone(this.timeForm.controls.endTime.value, DATE_HELPER_DEFAULT_TIME_ZONE)?.startOf('day').plus({days: 1}).toString(),
      ).subscribe(data => {
        this.parkingRangerSessions = data.items;
        this.selectedParkingRangerSession = null;
        this.showContent = true;
      });
    }
  }

  public rowSelected(args: RowSelectEventArgs): void {
    const parkingRangerSessions = args.data as ParkingRangerSessionDTO;
    this.selectedParkingRangerSessionId = parkingRangerSessions.id;
    if (args.data) {
      this.getSession();
    }
  }

  public tabToggle(toggleBoolean: boolean) {
    this.tabToggleStatus = toggleBoolean;
  }

  public getSession(): void {
    this.parkingRangerSessionsService.getParkingRangerSession(this.selectedParkingRangerSessionId).subscribe(data => {
      this.selectedParkingRangerSession = data;
    });
  }

  protected initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }
}
